import axios from 'axios';
const wxCodeUrlKey = '__WxCodeUrl__';
setUrl();

export function wxJsSdkInit() {
  return new Promise((resolve, reject) => {
    if (!isWeChat()) {
      reject();
      return;
    }

    const url = (isIos() ? localStorage.getItem(wxCodeUrlKey) : location.href).split('#')[0];

    axios
      .post('/learning/prod-api/auth/user/getWxUrlSignature', {
        url,
      })
      .then((res) => {
        if (res.data.code == 200) {
          const sign = {
            appId: res.data.data.appId, // 必填，公众号的唯一标识
            timestamp: res.data.data.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.data.data.noncestr, // 必填，生成签名的随机串
            signature: res.data.data.signature, // 必填，签名
          };

          window.wx.config({
            debug: location.href.includes('isTestDebugH5'),
            ...sign,
            jsApiList: ['getLocation', 'closeWindow', 'updateAppMessageShareData', 'updateTimelineShareData'],
            openTagList: ['wx-open-launch-weapp'],
          });

          window.wx.ready(() => {
            resolve();
          });
        } else {
          reject();
        }
      })
      .catch(() => {
        reject();
      });

    wx.error(() => {
      reject();
    });
  });
}

function setUrl() {
  localStorage.setItem(wxCodeUrlKey, location.href);
}

export function isWeChat() {
  var ua = window.navigator.userAgent.toLowerCase();

  return ua.match(/MicroMessenger/i) == 'micromessenger';
}

export function isIos() {
  return /iPhone|iPad|iPod/i.test(window.navigator.userAgent.toLowerCase());
}
